var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBlueCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00003 6.58597L12 0.5L13.5 2L6.00003 9.41397L0.293031 3.70697L1.70703 2.29297L6.00003 6.58597Z",
    fill: "#5796B9"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueCheckmark);
export default __webpack_public_path__ + "static/media/blueCheckmark.0bd0521db2b8e4e4c60a83926dc873b9.svg";
export { ForwardRef as ReactComponent };